import { Card, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import {
  SaveButton,
  SimpleForm,
  Toolbar,
  useDataProvider,
  useEditController,
  useNotify,
  usePermissions,
  useRecordContext,
  useRedirect,
} from "react-admin";
import { SubmitHandler } from "react-hook-form";
import { Navigate } from "react-router";
import { CrmDataProvider } from "../providers/types";
import { ScmConfigs } from "../types";
import { ScmConfigsInputs } from "./ScmConfigsInputs";

function EditToolbar() {
  return (
    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
      <SaveButton />
    </Toolbar>
  );
}

export function ScmConfigsEdit() {
  const { isPending, permissions } = usePermissions();
  const { record } = useEditController();
  const dataProvider = useDataProvider<CrmDataProvider>();
  const notify = useNotify();
  const redirect = useRedirect();

  const { mutate } = useMutation({
    mutationKey: ["signup"],
    mutationFn: async (data: ScmConfigs) => {
      if (!record) {
        throw new Error("Record not found");
      }
      return dataProvider.update("scmconfigs", {
        id: record.id,
        data: data,
        previousData: record,
      });
    },
    onSuccess: () => {
      redirect("/scmconfigs");
    },
    onError: (e: Error) => {
      notify(e.message, { type: "error" });
    },
  });

  const onSubmit: SubmitHandler<ScmConfigs> = async (data) => {
    mutate(data);
  };

  if (isPending) {
    return null;
  }

  if (permissions !== "admin") {
    return <Navigate to="/" />;
  }

  return (
    <Card>
      <SimpleForm
        toolbar={<EditToolbar />}
        onSubmit={onSubmit as SubmitHandler<any>}
        record={record}
      >
        <ScmConfigsEditTitle />
        <ScmConfigsInputs />
      </SimpleForm>
    </Card>
  );
}

const ScmConfigsEditTitle = () => {
  const record = useRecordContext<ScmConfigs>();
  if (!record) return null;
  return (
    <Typography variant="h6">
      Editar {record?.id} - {record?.nome_reduzido}
    </Typography>
  );
};
